(() => {
  const sync = (root) => {
    root.querySelectorAll('button[data-swatch-item]').forEach((button) => {
      const selected = button.classList.contains('is--selected');
      const unavailable = button.classList.contains('is--unavailable') || button.classList.contains('is--soldout') || button.classList.contains('is--sold-out');
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-disabled', String(unavailable));
    });
  };
  const init = () => {
    document.querySelectorAll('.t4s-swatch').forEach((root) => {
      if (root.dataset.wbAccessible) return;
      root.dataset.wbAccessible = 'true';
      sync(root);
      new MutationObserver(() => sync(root)).observe(root, { subtree: true, attributes: true, attributeFilter: ['class'] });
      root.addEventListener('click', () => {
        requestAnimationFrame(() => {
          const select = document.querySelector('main select.t4s-product__select[name="id"]');
          if (!root.closest('main') || !select || !select.value) return;
          const url = new URL(window.location.href);
          if (!url.pathname.includes('/products/')) return;
          url.searchParams.set('variant', select.value);
          window.history.replaceState(window.history.state, '', url);
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
